import { liftListItem, sinkListItem } from 'prosemirror-schema-list';
import { EditorState, Transaction } from 'prosemirror-state';

const MAX_LIST_DEPTH = 5;

/**
 * インデントを増やす（深さ制限付き）
 */
export function increaseListIndent(
  state: EditorState,
  dispatch: ((tr: Transaction) => void) | undefined,
): boolean {
  const { $from } = state.selection;

  const depth: number = Array.from({ length: $from.depth }).reduce((acc: number, _, i: number) => {
    const index = $from.depth - i - 1;
    return $from.node(index).type.name === 'listItem' ? acc + 1 : acc;
  }, 0);

  if (depth >= MAX_LIST_DEPTH) {
    return false;
  }

  return sinkListItem(state.schema.nodes.listItem)(state, dispatch);
}

/**
 * インデントを戻す
 */
export function outdentListItem(
  state: EditorState,
  dispatch: ((tr: Transaction) => void) | undefined,
): boolean {
  return liftListItem(state.schema.nodes.listItem)(state, dispatch);
}
